export default __webpack_public_path__ + "static/media/javascript-js-seeklogo.com.60e5130f.svg";